import moment from 'moment';

function formatTime(hour: number): string {
    const period = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${formattedHour.toString().padStart(2, '0')}:00 ${period}`;
}

export function getContinuousTimeRanges(hours: number[]): { startTime: string; endTime: string }[] {
    if (!hours.length) return [];

    const sortedHours = [...new Set(hours)].sort((a, b) => a - b);
    const result: { startTime: string; endTime: string }[] = [];

    let start = sortedHours[0];
    let prev = sortedHours[0];

    for (let i = 1; i < sortedHours.length; i++) {
        const current = sortedHours[i];
        if (current !== prev + 1) {
            result.push({
                startTime: formatTime(start),
                endTime: formatTime(prev + 1),
            });
            start = current;
        }
        prev = current;
    }

    // Push the last range
    result.push({
        startTime: formatTime(start),
        endTime: formatTime(prev + 1),
    });

    return result;
}

export function getTimeRangeFromSlots(slots: { value: string; label: string }[]) {
    if (!slots || slots.length === 0) return { startTime: null, endTime: null };

    const startTime = moment(slots[0].value, 'HH:mm').format('hh:mm A');
    const endTime = moment(slots[slots.length - 1].value, 'HH:mm')
        .add(1, 'hour')
        .format('hh:mm A');

    return [{ startTime, endTime }];
}
